<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="600px" @keydown="checkEsc">
      <v-card>
        <v-card-title class="d-flex">
          <span class="headline"
            >{{ $t('carHistory.carHistory') }}: {{ carName }}</span
          >
          <div class="input-holder d-flex search-holder ml-1">
            <v-text-field
              :label="searchLabel"
              v-model="carSearchValue"
              @keyup.enter="fetchData"
              hide-details
            ></v-text-field>
          </div>
        </v-card-title>
        <v-card-text>
          <div v-for="(itemDate, indexDate) in carHistoryData" :key="indexDate">
            <div>
              <div
                @click="
                  currentDate === itemDate.rowName
                    ? (currentDate = '')
                    : (currentDate = itemDate.rowName)
                "
                class="d-flex flex-row accordion-row"
                v-bind:class="{
                  'active-row': currentDate === itemDate.rowName,
                }"
              >
                <div class="d-flex flex-grow-0">
                  <v-avatar
                    v-if="itemDate.rowList.length === 0"
                    size="25px"
                    tile
                  >
                    <i aria-hidden="true" class="v-icon material-icons"
                      >highlight_off</i
                    >
                  </v-avatar>
                  <v-avatar
                    v-if="
                      currentDate !== itemDate.rowName &&
                        itemDate.rowList.length !== 0
                    "
                    size="25px"
                    tile
                  >
                    <i aria-hidden="true" class="v-icon material-icons">add</i>
                  </v-avatar>
                  <v-avatar
                    v-if="
                      currentDate === itemDate.rowName &&
                        itemDate.rowList.length !== 0
                    "
                    size="25px"
                    tile
                  >
                    <i aria-hidden="true" class="v-icon material-icons"
                      >remove</i
                    >
                  </v-avatar>
                </div>
                <div
                  class="date-txt-holder"
                  v-bind:class="{ unposted: itemDate.isPosted === '0' }"
                >
                  <h5>{{ itemDate.rowName }} от {{ itemDate.date }}</h5>
                </div>
                <v-avatar
                  @click.stop="openDoc(itemDate.docId, itemDate.docErr)"
                  size="25px"
                  tile
                >
                  <i aria-hidden="true" class="v-icon material-icons"
                    >zoom_in</i
                  >
                </v-avatar>
              </div>
              <div v-if="currentDate === itemDate.rowName">
                <div
                  v-for="(itemAuto, indexAuto) in itemDate.rowList"
                  :key="indexAuto"
                >
                  <div class="d-flex accordion-row auto-txt-holder">
                    <h6>{{ itemAuto.rowName }}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false">{{ $t('global.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from '@/services/axios'
import router from '@/router'
import i18n from '@/plugins/i18n'

export default {
  name: 'carHistory',
  data: () => ({
    dialog: false,
    carHistoryData: undefined,
    carName: '',
    currentDate: '',
    carSearchValue: '',
  }),
  computed: {
    globalTexts: function() {
      return i18n.messages[i18n.locale].global
    },
    carHistoryTexts: function() {
      return i18n.messages[i18n.locale].carHistory
    },
    searchLabel: function() {
      return this.globalTexts.plateNumber
    },
  },
  methods: {
    show(carSearchValue) {
      this.carSearchValue = carSearchValue
      this.fetchData()
      this.$nextTick(() => {
        this.dialog = true
      })
    },
    openDoc(id, err) {
      if (err) {
        this.$store.dispatch('showSnackMessage', { color: 'error', text: err })
      }
      router.push({ path: `/doczn/${id}` })
      this.dialog = false
      return false
    },
    fetchData() {
      this.workPlan = []
      if (!this.carSearchValue) {
        this.$store.dispatch('showSnackMessage', {
          color: 'info',
          text: this.carHistoryTexts.enterSearchValue,
        })
        return false
      }

      axios
        .request({
          url: '/CarHistory',
          params: {
            searchBy: this.carSearchValue,
          },
        })
        .then(resp => {
          this.carHistoryData = resp.data.carHistoryData
          this.carName = resp.data.carName
        })
    },
    checkEsc(ev) {
      if (ev.keyCode === 27) {
        this.dialog = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import '../_scss/mixins';
.accordion-row:hover {
  text-decoration: none;
  background: rgb(102, 80, 80);
}
.accordion-row h5 {
  margin-top: 2px;
}
.active-row {
  background: rgb(102, 80, 80);
}
.date-txt-holder {
  margin-left: 5px;
}
.auto-txt-holder {
  margin: 5px 5px;
}
.data-table-holder {
  border-width: 1px;
  padding: 5px 5px;
  border-style: dotted;
  border-color: coral;
}
.unposted {
  color: rgb(112, 128, 144);
}
</style>
